<template>
  <div>
    <div class="card-item checkin-content">
      <div id="checkin-welcome" class="card-content columns is-multiline">
        <div class="text-content column has-text-centered">
          <img class="thanks-image" src="../../../assets/img/checkin_gracias.svg">
          <h3>
            ¡Gracias {{ $store.state.currentUser && $store.state.currentUser.user ? $store.state.currentUser.user.name : '' }}!
          </h3>
          <p>Ya puedes ver y gestionar todo lo relacionado a tu crédito.</p>
          <p>Felicidades por cumplir tu meta del hogar propio!</p>
          <div class="has-text-centered">
            <div class="button-content transition-slow complete">
              <button
                id="continueButton"
                class="button is-button-primary is-rounded"
                @click="checkIn()">
                Ir a mis créditos
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkIn } from '@/application/services/api-clients/check-in';

export default {
  methods: {
    async checkIn() {
      try {
        await checkIn();
        await this.$store.dispatch('setCheckIn', this.$store.state.currentUser);
        this.$router.push({ name: 'main' });
      } catch (error) {
        console.error(error); // eslint-disable-line no-console
      }
    }
  }
};
</script>

<style lang="css" scoped>

.checkin-content {
    margin: 30px auto 50px;
    padding-top: 20px;
    padding-bottom: 50px;
    overflow: inherit;
}

#continueButton {
  margin-top: 50px;
}

@media (max-width: 380px) {
#checkin-welcome {
    padding: 0px;
}
.text-content {
  text-align: left !important;
}
}
.thanks-image{
  max-width: 200px;
}

.email {
  color: var(--primary);
}
</style>
